<template>
  <v-main>
    <template v-for="vm in vms.data" >
        <v-card
          style='border: 3px solid #292961;'
          class='ma-2'
          :key='getKey(vm)'
          flat
        >
          <v-card-title class="headline">{{vm.callerid | phoneNumber}}</v-card-title>

          <v-card-subtitle>{{vm.date_human}}</v-card-subtitle>

          <v-card-text>{{vm.transcript}}</v-card-text>
          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="play(vm)" icon x-large right v-bind='attrs' v-on='on'>
                  <v-icon v-if='vm.audio == undefined || (vm.audio != undefined && vm.audio.paused)'>mdi-play</v-icon>
                  <v-icon v-else>mdi-stop</v-icon>
                </v-btn>
              </template>
              <span v-if='vm.audio == undefined || (vm.audio != undefined && vm.audio.paused)'>Play</span>
              <span v-else>Pause</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-on:click="callBack(vm.callerid)"
                  icon x-large right v-bind='attrs' v-on='on'>
                    <v-icon>mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>Call Back</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on:click="deleteVM(vm)" icon x-large right v-bind='attrs' v-on='on'>
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
    </template>
  </v-main>
</template>

<script >
  import Common from '../mixins/common.vue';
  export default {
    mixins: [Common],
    data: function() {
      return {
        vms: {},
      }
    },
    props: {
    },
    methods: {
      debug: function(e) {
        console.log('debug: ', e)
      },
      updateList: function() {
        if ( this.click2call==='' ) {
          this.vms = {};
        } else {
          this.$http
            .get(global.apiurl + "/voicemail&token=" + this.click2call)
            .then( response => {
              this.vms = response.body;
          });
        }
      },
      updateList: function() {
        if ( this.click2call==='' ) {
          this.vms = {};
        } else {
          this.$http
            .get(global.apiurl + "/voicemail&token=" + this.click2call)
            .then( response => {
              this.vms = response.body;
          });
        }
      },
      callBack: function(number) {
        this.$store.commit('number',this.justNumbers(number));
        this.$router.push('/dialer');
      },
      dynamicSort: function(property) {
        var sortOrder = -1;
        if(property[0] === "-") {
            sortOrder = 1;
            property = property.substr(1);
        }
        return function (a,b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
      },
      strip: function(v) {
        return v.replace(/[^0-9]/g, '');
      },
      justNumbers: function(v) {
        return v.replace(/\(/g, '').replace(/\)/g,'');
      },
      getKey(vm) {
        return 'vm_' + vm.voicemail_id + vm.date_iso + vm.callerid + vm.transcript_accuracy;
      },
      async play(vm) {
        console.log(vm);
        if (typeof vm.audio != 'undefined' && !vm.audio.paused){
          vm.audio.pause();
          vm.audio.currentTime = 0;
        }
        else {  
          vm.audio = new Audio(global.expressAPIUrl + '/voicemail/audio?unique_id=' + vm.unique_id + '&token=' + this.click2call);  
          vm.audio.type = 'audio/wav';

          try {
            await vm.audio.play();
            console.log('Playing...');
          } 
          catch (err) {
            console.log('Failed to play...' + err);
          }
        }
      },
      async deleteVM(vm) {
        try {
          this.$http
            .post(global.expressAPIUrl + '/voicemail/delete?unique_id=' + vm.unique_id + '&token=' + this.click2call);
        } catch (err) {
          console.log('Failed to delete..' + err);
        }
      }
    },
    filters: {
      phoneNumber: function(value) {
        if ( value == 'Unknown' )
        {
          return 'Unknown';
        }
        return value
                .replace(/[^0-9]/g, '')
                .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
                .replace(/^(\d{1})(\d{3})(\d{3})(\d{4})$/, '$1 ($2) $3-$4');
      },
    },
    mounted() {
      this.updateList();
      // I don't need setInterval because router runs this every time
      //setInterval(()=> { this.updateList(); }, 60000);
      global.api.userAction('voicemail_read', null, 'webphone');
    },
    watch: {
      click2call() {
        this.updateList();
      },
    }
  }
</script>

<style scoped>
.invisible {
  display: none !important;
}
</style>
